import type { AdditionalDiagnostics } from 'owa-analytics-types';

export type PrivacyLoggingData = {
    additionalInfo?: AdditionalDiagnostics;
    error?: ErrorSummary;
    operationName?: string;
};

export type ErrorSummary = {
    additionalInfo?: AdditionalDiagnostics;
    message: string;
    name: string;
    stack: string | undefined;
};

export type PrivacyDiagnosticEvent = PrivacyLoggingData & {
    eventName: string;
    eventTimestamp: string;
};

const store: PrivacyDiagnosticEvent[] = [];

export const getPrivacyDiagnosticsStore = (): PrivacyDiagnosticEvent[] => store;

export function addPrivacyDiagnosticEvent(eventName: string, data: PrivacyLoggingData): void {
    store.push({
        ...data,
        eventName,
        eventTimestamp: new Date().toISOString(),
    });
}
